
<template>
  <router-link v-if="isInternalLink(link.url)" v-bind:title="link.title" v-bind:to="getUrlName(link.url)" v-on:click.native="clickHandler"><span>{{ text || link.title }}</span></router-link>
  <a v-else v-bind:title="link.title" v-bind:href="link.url"><span>{{ text || link.title }}</span></a>
</template>

<script>
    import {isInternalLink, getUrl} from '../../utils/UrlHelper';

    export default {
        props: ['link', 'text', 'onClick'],
        methods: {
            isInternalLink: url => isInternalLink(url),
            getUrlName: url => getUrl(url),
            clickHandler() {
              if (this.onClick) {
                this.onClick();
              }
            },
        }
    };
</script>

<style lang="scss">
</style>